module.exports = "/packs/005-5363b8fd58fa8eaebbb0da5eaed908e4.jpg";